export default __webpack_public_path__ + "static/media/Goldplay-Bold.be1e19f1.otf";